<div class="mg-contain">
  <div class="mg-contain__notifications">
    <div class="mg-contain__notifications__figure"></div>
    <div class="mg-contain__notifications__content">
      <div class="header bg-complementary-color-b md:bg-primary-color md:rounded-t-lg">
        <span class="title font-lato text-white">
          {{ notifications.length }}
          {{ "core.toolbar.notification" | translate }}
        </span>
      </div>
      <div class="body h-full overflow-x-auto md:h-96 md:border border-neutral-color-e rounded-b-lg bg-white">
        <div class="list px-3 font-lato text-neutral-color-a flex flex-col bg-white">
          <div class="content-list flex flex-row font-lato border-b pt-3 pb-1 border-neutral-color-e"
            *ngFor="let notification of notifications">
            <div class="w-full">
              <div class="close flex justify-end">
                <button (click)="closeNotification(notification.id)">
                  <img src="https://cdn.mango-soft.com/mango-core/close.svg" class="w-2.5 h-2.5" alt="close" />
                </button>
              </div>
              <div class="contain-notification flex w-full">
                <div class="image w-16">
                  <div class="flex items-center justify-center" *ngIf="notification.image">
                    <img [src]="notification.image" class="w-11 h-11" [alt]="notification.title" />
                  </div>
                </div>
                <div class="content pl-2 w-full flex flex-col">
                  <div class="title-contain-notification flex">
                    <div class="flex flex-col font-lato">
                      <span class="title text-xs font-normal">{{
                        notification.title
                        }}</span>
                      <span class="subtitle font-normal" style="font-size: 9px">
                        {{ notification.subtitle }}
                      </span>
                    </div>
                  </div>
                  <div class="flex justify-between font-lato items-center pt-2">
                    <div class="date font-normal text-neutral-color-b" style="font-size: 9px">
                      <span> {{ notification.date }} </span>
                    </div>
                    <div class="action" *ngIf="notification.url">
                      <button class="px-3 bg-neutral-color-d text--neutral-color-a rounded-lg font-lato font-normal"
                        style="font-size: 12px" (click)="openNotification(notification.url)">
                        Start
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>